import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  textfield: {
    background: '#FEFEFE',
    width: '10',
    height: '100'
  },
  photo: {
    height: 150,
    width: 300
  },
  paperEmpty: {
    padding: 10,
    width: 323
  },
  paperEmptyRecart: {
    padding: 10,
    width: 222
  },
  paperFullRecart: {
    padding: 10,
    width: 300
  },
  paperFull: {
    padding: 10,
    width: 380
  },
  label: {
    margin: 10
  },
  button: {
    backgroundColor: '#00B8E0',
    color: '#1A1A1A',
    margin: '10px',
    '&:hover': {
      backgroundColor: '#00B8E0',
      color: '#1A1A1A'
    }
  },
  containerCrop: {
    backgroundColor: '#F9F6F1'
  },
  cropContainer: {
    margin: 'auto',
    position: 'relative',
    width: '100%',
    height: 200,
    background: 'rgba(0, 0, 0, 0)',
    [theme.breakpoints.up('xl')]: {
      height: 400
    }
  },
  cropButton: {
    flexShrink: 0,
    marginInlineEnd: 16
  },
  controlCrop: {
    margin: 'auto',
    width: '100%',
    padding: 5,
    display: 'block',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center'
    }
  },
  sliderContainer: {
    display: 'flex',
    flex: '1',
    alignItems: 'center'
  },
  sliderLabel: {
    [theme.breakpoints.down('xs')]: {
      minWidth: 30
    }
  },
  slider: {
    padding: '22px 0px',
    marginInlineEnd: 16,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      margin: '0 16px'
    }
  }
}));

export { useStyles };
